import { baseUrl_SPB } from "../../../../../BaseUrl";

export const fetchFiskilTransactions = async (authToken, fiskilUserId, companyId) => {
  try {
    const url = `${baseUrl_SPB}/api/v1/fiskil/gettransactions?fiskilUserId=${encodeURIComponent(fiskilUserId)}&companyId=${encodeURIComponent(companyId)}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) throw new Error(`Backend responded with status: ${response.status}`);
    const jsonResponse = await response.json();

    return jsonResponse && jsonResponse.transactions ? jsonResponse.transactions : (Array.isArray(jsonResponse) ? jsonResponse : []);
  } catch (error) {
    console.error('Error in fetchFiskilTransactions:', error);
    throw error;
  }
};